export default __webpack_public_path__ + "media/bootstrap-icons.e559bf06.woff";